import { DynamicBlocks } from '~/dynamic-blocks';
import { usePage } from '~/services/cms';

export function ModulePage() {
  const { data: page } = usePage();

  return <DynamicBlocks elements={page?.pageElements} />;
}
